const state = {
  lines: [
    {
      code: "west",
      title: "Metro West"
    },
    {
      code: "greaterWest",
      title: "Greater West"
    },
    {
      code: "northWest",
      title: "NorthWest"
    },
    {
      code: "citySouthWest",
      title: "City and SouthWest"
    },
    {
      code: "futureProjects",
      title: "Future Projects"
    }
  ],
  stations: {
    west: [
      "Example Station X",
      "Pyrmont",
      "The Bays Precinct",
      "Five Dock",
      "Burwood North",
      "North Strathfield",
      "Olympic Park",
      "Silverwater",
      "Clyde",
      "Parramatta",
      "Westmead"
    ],
    greaterWest: [],
    northWest: [],
    citySouthWest: [],
    futureProjects: []
  },
  selectedLine: {},
  selectedStations: [],
  zones: [
    {
      code: "commercial",
      title: "Commercial",
      icon: "img/icons/projectIcon/commercial_icon.png",
      path: "/commercial"
    },
    {
      code: "reporting",
      title: "Reporting",
      icon: "img/icons/projectIcon/report_icon.png",
      path: "/reporting"
    },
    {
      code: "design",
      title: "Design",
      icon: "img/icons/projectIcon/design_icon.png",
      path: "/design"
    },
    {
      code: "collaboration",
      title: "Collaboration",
      icon: "img/icons/projectIcon/collab_icon.png",
      path: "/collaboration"
    },
    {
      code: "management",
      title: "Management",
      icon: "img/icons/projectIcon/management_icon.png",
      path: "/management"
    },
    {
      code: "innovation",
      title: "Research and Innovation",
      icon: "img/icons/projectIcon/innovation_icon.png",
      path: "/innovation"
    },
  ],
  categories: {
    commercial: [
      "Cost (Capex)",
      "Cost (Opex)",
      "Procurement and Supply Chain",
      "Contract"
    ],
    reporting: [
      "Monthly",
      "Weekly",
      "Live"
    ],
    design: [
      "Requirements",
      "Reports & Deliverables",
      "Design Models",
      "Sustainability"
    ],
    collaboration: [
      "Correspondence Management",
      "File Transfer",
      "Contact List",
      "Meetings",
      "Action Lists",
      "Risk and Issue Management",
      "Document Management",
      "Shared Calendar",
      "Interface Management",
      "Stakeholder Management"
    ],
    management: [
      "Management Plans",
      "Passport (Inductions)",
      "Resource Management",
      "Planning and Scheduling",
      "Change Control",
      "Health and Safety"
    ],
    innovation: [
      "Innovation"
    ]
  },
  selectedZone: {},
  selectedCategories: [],
  counter: 0,
  activeTabFlags: {
    insightSection: false,
    bim360Section: false,
    GISDashboardSection: false,
    GISPortalSection: false,
    simulationSection: false,
    opsSection: false,
    teamBinderSection: false
  },
  portfolios: [
    {
      code: "passenger_service",
      title: "Passenger Services"
    },
    {
      code: "other_lines",
      title: "Other Lines"
    },
    {
      code: "closed_lines",
      title: "Closed Lines"
    }
  ],
  projects: {
    passenger_service: [
      "Muswellbrook",
      "Station A",
      "Station B",
      "Station C",
      "Station D"
    ],
    other_lines: [
      "Station E",
      "Station F",
      "Station G",
      "Station H",
      "Station I"
    ],
    closed_lines: [
      "Station J",
      "Station K",
      "Station L",
      "Station M",
      "Station N"
    ]
  },
  projectTabs: [
    {
      zoneCode: "commercial",
      items: [
        {
          category: "Cost (Capex)",
          tabs: [
            {
              title: "INSIGHT",
              url: "img/assets/tabs/InsightTab2.png"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "img/assets/tabs/InfoExchangeTab.png"
            },
            {
              title: "GIS",
              url: "img/assets/tabs/GISTab.png"
            },
            {
              title: "MODEL REVIEW",
              url: "img/assets/tabs/ModelReviewTab2.png"
            },
            {
              title: "MODEL COORDINATION",
              url: "img/assets/tabs/ModelReviewTab.png"
            }
          ]
        },
        {
          category: "Cost (Opex)",
          tabs: [
            {
              title: "INSIGHT",
              url: "img/assets/tabs/InsightTab2.png"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "img/assets/tabs/InfoExchangeTab.png"
            },
            {
              title: "GIS",
              url: "img/assets/tabs/GISTab.png"
            },
            {
              title: "MODEL REVIEW",
              url: "img/assets/tabs/ModelReviewTab2.png"
            },
            {
              title: "MODEL COORDINATION",
              url: "img/assets/tabs/ModelReviewTab.png"
            }
          ]
        },
        {
          category: "Procurement and Supply Chain",
          tabs: [
            {
              title: "INSIGHT",
              url: "img/assets/tabs/InsightTab2.png"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "img/assets/tabs/InfoExchangeTab.png"
            },
            {
              title: "GIS",
              url: "img/assets/tabs/GISTab.png"
            },
            {
              title: "MODEL REVIEW",
              url: "img/assets/tabs/ModelReviewTab2.png"
            },
            {
              title: "MODEL COORDINATION",
              url: "img/assets/tabs/ModelReviewTab.png"
            }
          ]
        },
        {
          category: "Contract",
          tabs: [
            {
              title: "INSIGHT",
              url: "img/assets/tabs/InsightTab2.png"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "img/assets/tabs/InfoExchangeTab.png"
            },
            {
              title: "GIS",
              url: "img/assets/tabs/GISTab.png"
            },
            {
              title: "MODEL REVIEW",
              url: "img/assets/tabs/ModelReviewTab2.png"
            },
            {
              title: "MODEL COORDINATION",
              url: "img/assets/tabs/ModelReviewTab.png"
            }
          ]
        }
      ]
    },{
      zoneCode: "reporting",
      items: [
        {
          category: "Monthly",
          tabs: [
            {
              title: "INSIGHT",
              url: "img/assets/tabs/InsightTab2.png"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "img/assets/tabs/InfoExchangeTab.png"
            },
            {
              title: "GIS",
              url: "img/assets/tabs/GISTab.png"
            },
            {
              title: "MODEL REVIEW",
              url: "img/assets/tabs/ModelReviewTab2.png"
            },
            {
              title: "MODEL COORDINATION",
              url: "img/assets/tabs/ModelReviewTab.png"
            }
          ]
        },
        {
          category: "Weekly",
          tabs: [
            {
              title: "INSIGHT",
              url: "img/assets/tabs/InsightTab2.png"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "img/assets/tabs/InfoExchangeTab.png"
            },
            {
              title: "GIS",
              url: "img/assets/tabs/GISTab.png"
            },
            {
              title: "MODEL REVIEW",
              url: "img/assets/tabs/ModelReviewTab2.png"
            },
            {
              title: "MODEL COORDINATION",
              url: "img/assets/tabs/ModelReviewTab.png"
            }
          ]
        },
        {
          category: "Live",
          tabs: [
            {
              title: "INSIGHT",
              url: "img/assets/tabs/InsightTab2.png"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "img/assets/tabs/InfoExchangeTab.png"
            },
            {
              title: "GIS",
              url: "img/assets/tabs/GISTab.png"
            },
            {
              title: "MODEL REVIEW",
              url: "img/assets/tabs/ModelReviewTab2.png"
            },
            {
              title: "MODEL COORDINATION",
              url: "img/assets/tabs/ModelReviewTab.png"
            }
          ]
        },
      ]
    },{
      zoneCode: "design",
      items: [
        {
          category: "Requirements",
          tabs: [
            {
              title: "INSIGHT",
              url: "img/assets/tabs/InsightTab2.png"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "img/assets/tabs/InfoExchangeTab.png"
            },
            {
              title: "GIS",
              url: "img/assets/tabs/GISTab.png"
            },
            {
              title: "MODEL REVIEW",
              url: "img/assets/tabs/ModelReviewTab2.png"
            },
            {
              title: "MODEL COORDINATION",
              url: "img/assets/tabs/ModelReviewTab.png"
            }
          ]
        },
        {
          category: "Reports & Deliverables",
          tabs: [
            {
              title: "INSIGHT",
              url: "img/assets/tabs/InsightTab2.png"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "img/assets/tabs/InfoExchangeTab.png"
            },
            {
              title: "GIS",
              url: "img/assets/tabs/GISTab.png"
            },
            {
              title: "MODEL REVIEW",
              url: "img/assets/tabs/ModelReviewTab2.png"
            },
            {
              title: "MODEL COORDINATION",
              url: "img/assets/tabs/ModelReviewTab.png"
            }
          ]
        },
        {
          category: "Design Models",
          tabs: [
            {
              title: "INSIGHT",
              url: "img/assets/tabs/InsightTab2.png"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "img/assets/tabs/InfoExchangeTab.png"
            },
            {
              title: "GIS",
              url: "img/assets/tabs/GISTab.png"
            },
            {
              title: "MODEL REVIEW",
              url: "img/assets/tabs/ModelReviewTab2.png"
            },
            {
              title: "MODEL COORDINATION",
              url: "img/assets/tabs/ModelReviewTab.png"
            }
          ]
        },
        {
          category: "Sustainability",
          tabs: [
            {
              title: "INSIGHT",
              url: "img/assets/tabs/InsightTab2.png"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "img/assets/tabs/InfoExchangeTab.png"
            },
            {
              title: "GIS",
              url: "img/assets/tabs/GISTab.png"
            },
            {
              title: "MODEL REVIEW",
              url: "img/assets/tabs/ModelReviewTab2.png"
            },
            {
              title: "MODEL COORDINATION",
              url: "img/assets/tabs/ModelReviewTab.png"
            }
          ]
        }
      ]
    },{
      zoneCode: "collaboration",
      items: [
        {
          category: "Correspondence Management",
          tabs: [
            {
              title: "INSIGHT",
              url: "img/assets/tabs/InsightTab2.png"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "img/assets/tabs/InfoExchangeTab.png"
            },
            {
              title: "GIS",
              url: "img/assets/tabs/GISTab.png"
            },
            {
              title: "MODEL REVIEW",
              url: "img/assets/tabs/ModelReviewTab2.png"
            },
            {
              title: "MODEL COORDINATION",
              url: "img/assets/tabs/ModelReviewTab.png"
            }
          ]
        },
        {
          category: "File Transfer",
          tabs: [
            {
              title: "INSIGHT",
              url: "img/assets/tabs/InsightTab2.png"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "img/assets/tabs/InfoExchangeTab.png"
            },
            {
              title: "GIS",
              url: "img/assets/tabs/GISTab.png"
            },
            {
              title: "MODEL REVIEW",
              url: "img/assets/tabs/ModelReviewTab2.png"
            },
            {
              title: "MODEL COORDINATION",
              url: "img/assets/tabs/ModelReviewTab.png"
            }
          ]
        },
        {
          category: "Contact List",
          tabs: [
            {
              title: "INSIGHT",
              url: "img/assets/tabs/InsightTab2.png"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "img/assets/tabs/InfoExchangeTab.png"
            },
            {
              title: "GIS",
              url: "img/assets/tabs/GISTab.png"
            },
            {
              title: "MODEL REVIEW",
              url: "img/assets/tabs/ModelReviewTab2.png"
            },
            {
              title: "MODEL COORDINATION",
              url: "img/assets/tabs/ModelReviewTab.png"
            }
          ]
        },
        {
          category: "Meetings",
          tabs: [
            {
              title: "INSIGHT",
              url: "img/assets/tabs/InsightTab2.png"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "img/assets/tabs/InfoExchangeTab.png"
            },
            {
              title: "GIS",
              url: "img/assets/tabs/GISTab.png"
            },
            {
              title: "MODEL REVIEW",
              url: "img/assets/tabs/ModelReviewTab2.png"
            },
            {
              title: "MODEL COORDINATION",
              url: "img/assets/tabs/ModelReviewTab.png"
            }
          ]
        },
        {
          category: "Action Lists",
          tabs: [
            {
              title: "INSIGHT",
              url: "img/assets/tabs/InsightTab2.png"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "img/assets/tabs/InfoExchangeTab.png"
            },
            {
              title: "GIS",
              url: "img/assets/tabs/GISTab.png"
            },
            {
              title: "MODEL REVIEW",
              url: "img/assets/tabs/ModelReviewTab2.png"
            },
            {
              title: "MODEL COORDINATION",
              url: "img/assets/tabs/ModelReviewTab.png"
            }
          ]
        },
        {
          category: "Risk and Issue Management",
          tabs: [
            {
              title: "INSIGHT",
              url: "img/assets/tabs/InsightTab2.png"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "img/assets/tabs/InfoExchangeTab.png"
            },
            {
              title: "GIS",
              url: "img/assets/tabs/GISTab.png"
            },
            {
              title: "MODEL REVIEW",
              url: "img/assets/tabs/ModelReviewTab2.png"
            },
            {
              title: "MODEL COORDINATION",
              url: "img/assets/tabs/ModelReviewTab.png"
            }
          ]
        },
        {
          category: "Document Management",
          tabs: [
            {
              title: "INSIGHT",
              url: "img/assets/tabs/InsightTab2.png"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "img/assets/tabs/InfoExchangeTab.png"
            },
            {
              title: "GIS",
              url: "img/assets/tabs/GISTab.png"
            },
            {
              title: "MODEL REVIEW",
              url: "img/assets/tabs/ModelReviewTab2.png"
            },
            {
              title: "MODEL COORDINATION",
              url: "img/assets/tabs/ModelReviewTab.png"
            }
          ]
        },
        {
          category: "Shared Calendar",
          tabs: [
            {
              title: "INSIGHT",
              url: "img/assets/tabs/InsightTab2.png"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "img/assets/tabs/InfoExchangeTab.png"
            },
            {
              title: "GIS",
              url: "img/assets/tabs/GISTab.png"
            },
            {
              title: "MODEL REVIEW",
              url: "img/assets/tabs/ModelReviewTab2.png"
            },
            {
              title: "MODEL COORDINATION",
              url: "img/assets/tabs/ModelReviewTab.png"
            }
          ]
        },
        {
          category: "Interface Management",
          tabs: [
            {
              title: "INSIGHT",
              url: "img/assets/tabs/InsightTab2.png"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "img/assets/tabs/InfoExchangeTab.png"
            },
            {
              title: "GIS",
              url: "img/assets/tabs/GISTab.png"
            },
            {
              title: "MODEL REVIEW",
              url: "img/assets/tabs/ModelReviewTab2.png"
            },
            {
              title: "MODEL COORDINATION",
              url: "img/assets/tabs/ModelReviewTab.png"
            }
          ]
        },
        {
          category: "Stakeholder Management",
          tabs: [
            {
              title: "INSIGHT",
              url: "img/assets/tabs/InsightTab2.png"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "img/assets/tabs/InfoExchangeTab.png"
            },
            {
              title: "GIS",
              url: "img/assets/tabs/GISTab.png"
            },
            {
              title: "MODEL REVIEW",
              url: "img/assets/tabs/ModelReviewTab2.png"
            },
            {
              title: "MODEL COORDINATION",
              url: "img/assets/tabs/ModelReviewTab.png"
            }
          ]
        }
      ]
    },{
      zoneCode: "management",
      items: [
        {
          category: "Management Plans",
          tabs: [
            {
              title: "INSIGHT",
              url: "img/assets/tabs/InsightTab2.png"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "img/assets/tabs/InfoExchangeTab.png"
            },
            {
              title: "GIS",
              url: "img/assets/tabs/GISTab.png"
            },
            {
              title: "MODEL REVIEW",
              url: "img/assets/tabs/ModelReviewTab2.png"
            },
            {
              title: "MODEL COORDINATION",
              url: "img/assets/tabs/ModelReviewTab.png"
            }
          ]
        },
        {
          category: "Passport (Inductions)",
          tabs: [
            {
              title: "INSIGHT",
              url: "img/assets/tabs/InsightTab2.png"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "img/assets/tabs/InfoExchangeTab.png"
            },
            {
              title: "GIS",
              url: "img/assets/tabs/GISTab.png"
            },
            {
              title: "MODEL REVIEW",
              url: "img/assets/tabs/ModelReviewTab2.png"
            },
            {
              title: "MODEL COORDINATION",
              url: "img/assets/tabs/ModelReviewTab.png"
            }
          ]
        },
        {
          category: "Resource Management",
          tabs: [
            {
              title: "INSIGHT",
              url: "img/assets/tabs/InsightTab2.png"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "img/assets/tabs/InfoExchangeTab.png"
            },
            {
              title: "GIS",
              url: "img/assets/tabs/GISTab.png"
            },
            {
              title: "MODEL REVIEW",
              url: "img/assets/tabs/ModelReviewTab2.png"
            },
            {
              title: "MODEL COORDINATION",
              url: "img/assets/tabs/ModelReviewTab.png"
            }
          ]
        },
        {
          category: "Planning and Scheduling",
          tabs: [
            {
              title: "INSIGHT",
              url: "img/assets/tabs/InsightTab2.png"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "img/assets/tabs/InfoExchangeTab.png"
            },
            {
              title: "GIS",
              url: "img/assets/tabs/GISTab.png"
            },
            {
              title: "MODEL REVIEW",
              url: "img/assets/tabs/ModelReviewTab2.png"
            },
            {
              title: "MODEL COORDINATION",
              url: "img/assets/tabs/ModelReviewTab.png"
            }
          ]
        },
        {
          category: "Change Control",
          tabs: [
            {
              title: "INSIGHT",
              url: "img/assets/tabs/InsightTab2.png"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "img/assets/tabs/InfoExchangeTab.png"
            },
            {
              title: "GIS",
              url: "img/assets/tabs/GISTab.png"
            },
            {
              title: "MODEL REVIEW",
              url: "img/assets/tabs/ModelReviewTab2.png"
            },
            {
              title: "MODEL COORDINATION",
              url: "img/assets/tabs/ModelReviewTab.png"
            }
          ]
        },
        {
          category: "Health and Safety",
          tabs: [
            {
              title: "INSIGHT",
              url: "img/assets/tabs/InsightTab2.png"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "img/assets/tabs/InfoExchangeTab.png"
            },
            {
              title: "GIS",
              url: "img/assets/tabs/GISTab.png"
            },
            {
              title: "MODEL REVIEW",
              url: "img/assets/tabs/ModelReviewTab2.png"
            },
            {
              title: "MODEL COORDINATION",
              url: "img/assets/tabs/ModelReviewTab.png"
            }
          ]
        },
      ]
    },{
      zoneCode: "innovation",
      items: [
        {
          category: "Innovation",
          tabs: [
            {
              title: "INSIGHT",
              url: "img/assets/tabs/InsightTab2.png"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "img/assets/tabs/InfoExchangeTab.png"
            },
            {
              title: "GIS",
              url: "img/assets/tabs/GISTab.png"
            },
            {
              title: "MODEL REVIEW",
              url: "img/assets/tabs/ModelReviewTab2.png"
            },
            {
              title: "MODEL COORDINATION",
              url: "img/assets/tabs/ModelReviewTab.png"
            }
          ]
        }
      ]
    }
  ],
  selectedPortfolio: {},
  selectedProjects: [],
  currentSelectedProject: "",
  currentSelectedSubCategory: "",
  currentSelectedProjectTab: {
    category: "",
    tabs: [
    ]
  }
}

function initialState() {
  return {
    lines: [
      {
        code: "west",
        title: "Metro West"
      },
      {
        code: "greaterWest",
        title: "Greater West"
      },
      {
        code: "northWest",
        title: "NorthWest"
      },
      {
        code: "citySouthWest",
        title: "City and SouthWest"
      },
      {
        code: "futureProjects",
        title: "Future Projects"
      }
    ],
    stations: {
      west: [
        "Example Station X",
        "Pyrmont",
        "The Bays Precinct",
        "Five Docks",
        "Burwood North",
        "North Strathfield",
        "Olympic Park",
        "Silverwater",
        "Clyde",
        "Paramatta",
        "Westmead"
      ],
      greaterWest: [],
      northWest: [],
      citySouthWest: [],
      futureProjects: []
    },
    selectedLine: {},
    selectedStations: [],
    zones: [
      {
        code: "commercial",
        title: "Commercial",
        icon: "img/icons/projectIcon/commercial_icon.png",
        path: "/commercial"
      },
      {
        code: "reporting",
        title: "Reporting",
        icon: "img/icons/projectIcon/report_icon.png",
        path: "/reporting"
      },
      {
        code: "design",
        title: "Design",
        icon: "img/icons/projectIcon/design_icon.png",
        path: "/design"
      },
      {
        code: "collaboration",
        title: "Collaboration",
        icon: "img/icons/projectIcon/collab_icon.png",
        path: "/collaboration"
      },
      {
        code: "management",
        title: "Management",
        icon: "img/icons/projectIcon/management_icon.png",
        path: "/management"
      },
      {
        code: "innovation",
        title: "Research and Innovation",
        icon: "img/icons/projectIcon/innovation_icon.png",
        path: "/innovation"
      },
    ],
    categories: {
      commercial: [
        "Cost (Capex)",
        "Cost (Opex)",
        "Procurement and Supply Chain",
        "Contract"
      ],
      reporting: [
        "Monthly",
        "Weekly",
        "Live"
      ],
      design: [
        "Requirements",
        "Reports & Deliverables",
        "Design Models",
        "Sustainability"
      ],
      collaboration: [
        "Correspondence Management",
        "File Transfer",
        "Contact List",
        "Meetings",
        "Action Lists",
        "Risk and Issue Management",
        "Document Management",
        "Shared Calendar",
        "Interface Management",
        "Stakeholder Management"
      ],
      management: [
        "Management Plans",
        "Passport (Inductions)",
        "Resource Management",
        "Planning and Scheduling",
        "Change Control",
        "Health and Safety"
      ],
      innovation: [
        "Innovation"
      ]
    },
    selectedZone: {},
    selectedCategories: [],
    counter: 0,
    activeTabFlags: {
      insightSection: false,
      bim360Section: false,
      GISDashboardSection: false,
      GISPortalSection: false,
      simulationSection: false,
      opsSection: false,
      teamBinderSection: false
    },
    portfolios: [
      {
        code: "passenger_service",
        title: "Passenger Services"
      },
      {
        code: "other_lines",
        title: "Other Lines"
      },
      {
        code: "closed_lines",
        title: "Closed Lines"
      }
    ],
    projects: {
      passenger_service: [
        "Muswellbrook",
        "Station A",
        "Station B",
        "Station C",
        "Station D"
      ],
      other_lines: [
        "Station E",
        "Station F",
        "Station G",
        "Station H",
        "Station I"
      ],
      closed_lines: [
        "Station J",
        "Station K",
        "Station L",
        "Station M",
        "Station N"
      ]
    },
    projectTabs: [
      {
        zoneCode: "commercial",
        items: [
          {
            category: "Cost (Capex)",
            tabs: [
              {
                title: "INSIGHT",
                url: "img/assets/tabs/InsightTab2.png"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "GIS",
                url: "img/assets/tabs/GISTab.png"
              },
              {
                title: "MODEL REVIEW",
                url: "img/assets/tabs/ModelReviewTab2.png"
              }
            ]
          },
          {
            category: "Cost (Opex)",
            tabs: [
              {
                title: "INSIGHT",
                url: "img/assets/tabs/InsightTab2.png"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "GIS",
                url: "img/assets/tabs/GISTab.png"
              },
              {
                title: "MODEL REVIEW",
                url: "img/assets/tabs/ModelReviewTab2.png"
              }
            ]
          },
          {
            category: "Procurement and Supply Chain",
            tabs: [
              {
                title: "INSIGHT",
                url: "img/assets/tabs/InsightTab2.png"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "GIS",
                url: "img/assets/tabs/GISTab.png"
              },
              {
                title: "MODEL REVIEW",
                url: "img/assets/tabs/ModelReviewTab2.png"
              }
            ]
          },
          {
            category: "Contract",
            tabs: [
              {
                title: "INSIGHT",
                url: "img/assets/tabs/InsightTab2.png"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "GIS",
                url: "img/assets/tabs/GISTab.png"
              },
              {
                title: "MODEL REVIEW",
                url: "img/assets/tabs/ModelReviewTab2.png"
              }
            ]
          }
        ]
      },{
        zoneCode: "reporting",
        items: [
          {
            category: "Monthly",
            tabs: [
              {
                title: "INSIGHT",
                url: ""
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "GIS",
                url: "img/assets/tabs/GISTab.png"
              },
              {
                title: "MODEL REVIEW",
                url: "img/assets/tabs/ModelReviewTab2.png"
              }
            ]
          },
          {
            category: "Weekly",
            tabs: [
              {
                title: "INSIGHT",
                url: ""
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "GIS",
                url: "img/assets/tabs/GISTab.png"
              },
              {
                title: "MODEL REVIEW",
                url: "img/assets/tabs/ModelReviewTab2.png"
              }
            ]
          },
          {
            category: "Live",
            tabs: [
              {
                title: "INSIGHT",
                url: ""
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "GIS",
                url: "img/assets/tabs/GISTab.png"
              },
              {
                title: "MODEL REVIEW",
                url: "img/assets/tabs/ModelReviewTab2.png"
              }
            ]
          },
        ]
      },{
        zoneCode: "design",
        items: [
          {
            category: "Requirements",
            tabs: [
              {
                title: "INSIGHT",
                url: ""
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "GIS",
                url: "img/assets/tabs/GISTab.png"
              },
              {
                title: "MODEL REVIEW",
                url: "img/assets/tabs/ModelReviewTab2.png"
              }
            ]
          },
          {
            category: "Reports & Deliverables",
            tabs: [
              {
                title: "INSIGHT",
                url: ""
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "GIS",
                url: "img/assets/tabs/GISTab.png"
              },
              {
                title: "MODEL REVIEW",
                url: "img/assets/tabs/ModelReviewTab2.png"
              }
            ]
          },
          {
            category: "Design Models",
            tabs: [
              {
                title: "INSIGHT",
                url: ""
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "GIS",
                url: "img/assets/tabs/GISTab.png"
              },
              {
                title: "MODEL REVIEW",
                url: "img/assets/tabs/ModelReviewTab2.png"
              }
            ]
          },
          {
            category: "Sustainability",
            tabs: [
              {
                title: "INSIGHT",
                url: ""
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "GIS",
                url: "img/assets/tabs/GISTab.png"
              },
              {
                title: "MODEL REVIEW",
                url: "img/assets/tabs/ModelReviewTab2.png"
              }
            ]
          }
        ]
      },{
        zoneCode: "collaboration",
        items: [
          {
            category: "Correspondence Management",
            tabs: [
              {
                title: "INSIGHT",
                url: ""
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "GIS",
                url: "img/assets/tabs/GISTab.png"
              },
              {
                title: "MODEL REVIEW",
                url: "img/assets/tabs/ModelReviewTab2.png"
              }
            ]
          },
          {
            category: "File Transfer",
            tabs: [
              {
                title: "INSIGHT",
                url: ""
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "GIS",
                url: "img/assets/tabs/GISTab.png"
              },
              {
                title: "MODEL REVIEW",
                url: "img/assets/tabs/ModelReviewTab2.png"
              }
            ]
          },
          {
            category: "Contact List",
            tabs: [
              {
                title: "INSIGHT",
                url: ""
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "GIS",
                url: "img/assets/tabs/GISTab.png"
              },
              {
                title: "MODEL REVIEW",
                url: "img/assets/tabs/ModelReviewTab2.png"
              }
            ]
          },
          {
            category: "Meetings",
            tabs: [
              {
                title: "INSIGHT",
                url: ""
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "GIS",
                url: "img/assets/tabs/GISTab.png"
              },
              {
                title: "MODEL REVIEW",
                url: "img/assets/tabs/ModelReviewTab2.png"
              }
            ]
          },
          {
            category: "Action Lists",
            tabs: [
              {
                title: "INSIGHT",
                url: ""
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "GIS",
                url: "img/assets/tabs/GISTab.png"
              },
              {
                title: "MODEL REVIEW",
                url: "img/assets/tabs/ModelReviewTab2.png"
              }
            ]
          },
          {
            category: "Risk and Issue Management",
            tabs: [
              {
                title: "INSIGHT",
                url: ""
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "GIS",
                url: "img/assets/tabs/GISTab.png"
              },
              {
                title: "MODEL REVIEW",
                url: "img/assets/tabs/ModelReviewTab2.png"
              }
            ]
          },
          {
            category: "Document Management",
            tabs: [
              {
                title: "INSIGHT",
                url: ""
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "GIS",
                url: "img/assets/tabs/GISTab.png"
              },
              {
                title: "MODEL REVIEW",
                url: "img/assets/tabs/ModelReviewTab2.png"
              }
            ]
          },
          {
            category: "Shared Calendar",
            tabs: [
              {
                title: "INSIGHT",
                url: ""
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "GIS",
                url: "img/assets/tabs/GISTab.png"
              },
              {
                title: "MODEL REVIEW",
                url: "img/assets/tabs/ModelReviewTab2.png"
              }
            ]
          },
          {
            category: "Interface Management",
            tabs: [
              {
                title: "INSIGHT",
                url: ""
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "GIS",
                url: "img/assets/tabs/GISTab.png"
              },
              {
                title: "MODEL REVIEW",
                url: "img/assets/tabs/ModelReviewTab2.png"
              }
            ]
          },
          {
            category: "Stakeholder Management",
            tabs: [
              {
                title: "INSIGHT",
                url: ""
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "GIS",
                url: "img/assets/tabs/GISTab.png"
              },
              {
                title: "MODEL REVIEW",
                url: "img/assets/tabs/ModelReviewTab2.png"
              }
            ]
          }
        ]
      },{
        zoneCode: "management",
        items: [
          {
            category: "Management Plans",
            tabs: [
              {
                title: "INSIGHT",
                url: ""
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "GIS",
                url: "img/assets/tabs/GISTab.png"
              },
              {
                title: "MODEL REVIEW",
                url: "img/assets/tabs/ModelReviewTab2.png"
              }
            ]
          },
          {
            category: "Passport (Inductions)",
            tabs: [
              {
                title: "INSIGHT",
                url: ""
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "GIS",
                url: "img/assets/tabs/GISTab.png"
              },
              {
                title: "MODEL REVIEW",
                url: "img/assets/tabs/ModelReviewTab2.png"
              }
            ]
          },
          {
            category: "Resource Management",
            tabs: [
              {
                title: "INSIGHT",
                url: ""
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "GIS",
                url: "img/assets/tabs/GISTab.png"
              },
              {
                title: "MODEL REVIEW",
                url: "img/assets/tabs/ModelReviewTab2.png"
              }
            ]
          },
          {
            category: "Planning and Scheduling",
            tabs: [
              {
                title: "INSIGHT",
                url: ""
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "GIS",
                url: "img/assets/tabs/GISTab.png"
              },
              {
                title: "MODEL REVIEW",
                url: "img/assets/tabs/ModelReviewTab2.png"
              }
            ]
          },
          {
            category: "Change Control",
            tabs: [
              {
                title: "INSIGHT",
                url: ""
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "GIS",
                url: "img/assets/tabs/GISTab.png"
              },
              {
                title: "MODEL REVIEW",
                url: "img/assets/tabs/ModelReviewTab2.png"
              }
            ]
          },
          {
            category: "Health and Safety",
            tabs: [
              {
                title: "INSIGHT",
                url: ""
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "GIS",
                url: "img/assets/tabs/GISTab.png"
              },
              {
                title: "MODEL REVIEW",
                url: "img/assets/tabs/ModelReviewTab2.png"
              }
            ]
          },
        ]
      },{
        zoneCode: "innovation",
        items: [
          {
            category: "Innovation",
            tabs: [
              {
                title: "INSIGHT",
                url: ""
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "GIS",
                url: "img/assets/tabs/GISTab.png"
              },
              {
                title: "MODEL REVIEW",
                url: "img/assets/tabs/ModelReviewTab2.png"
              }
            ]
          }
        ]
      }
    ],
    selectedPortfolio: {},
    selectedProjects: [],
    currentSelectedProject: "",
    currentSelectedSubCategory: "",
    currentSelectedProjectTab: {
      category: "",
      tabs: [
      ]
    }
  }
}

const mutations = {
  upCounter(state) {
    state.counter += 1
  },
  setSelectedZone(state, payload) {
    var selectedZone = state.zones.filter(obj=>obj.code == payload)[0]
    state.selectedZone = selectedZone
  },
  setCategoriesFromZone(state, payload) {
    var categories = state.categories[payload]
    state.selectedCategories = categories
  },
  setSelectedLine(state, payload) {
    var selectedLine = state.lines.filter(obj=>obj.code == payload)[0]
    state.selectedLine = selectedLine
    console.log(selectedLine);
  },
  setSelectedStations(state, payload) {
    state.selectedStations = state.stations[payload]
  },
  setActiveTabFlags(state, payload) {
    state.activeTabFlags[payload] = true
  },
  setSelectedPortfolio(state, payload) {
    var selectedPortfolio = state.portfolios.filter(obj=>obj.code == payload)[0]
    state.selectedPortfolio = selectedPortfolio
  },
  setSelectedProjects(state, payload) {
    state.selectedProjects = state.projects[payload]
  },
  setCurrentSelectedSubCategory(state, payload) {
    state.currentSelectedSubCategory = payload
  },
  setCurrentSelectedProject(state, payload) {
    state.currentSelectedProject = payload
  },
  setCurrentSelectedProjectTab(state, payload) {
    state.currentSelectedProjectTab = payload
  },
}

const actions = {

}

const getters = {

}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
